import { pushToDataLayer } from "@/lib/data-measurements/datalayer";
import { Property } from "@/lib/types/marketsuite/datatypes/property";

type PropertyLike = Partial<Property>;
type PropertyEcommerceItem = {
	item_id: string;
	item_name: string;
	item_category?: string;
	price?: number;
	index?: number;
};

const trackedKeys = new Set<string>();

function toPropertyEcommerceItem(property: PropertyLike, index?: number): PropertyEcommerceItem | null {
	if (property.id == null || typeof property.title !== "string" || property.title.length === 0) {
		return null;
	}

	return {
		item_id: String(property.id),
		item_name: property.title,
		item_category: typeof property.listing_type === "string" ? property.listing_type : undefined,
		price: typeof property.handover?.price === "number" ? property.handover.price : undefined,
		index,
	};
}

function pushEcommerceEvent(event: "view_item_list" | "select_item" | "view_item", ecommerce: Record<string, unknown>) {
	pushToDataLayer({ event, ecommerce });
}

export function trackPropertyViewItemList(properties: PropertyLike[], listId: string, listName: string): void {
	const items = properties.map((property, index) => toPropertyEcommerceItem(property, index)).filter((item): item is PropertyEcommerceItem => item !== null);

	if (items.length === 0) return;

	const key = `view_item_list:${listId}:${items.map((item) => item.item_id).join(",")}`;
	if (trackedKeys.has(key)) return;
	trackedKeys.add(key);

	pushEcommerceEvent("view_item_list", {
		item_list_id: listId,
		item_list_name: listName,
		items,
	});
}

export function trackPropertySelectItem(property: PropertyLike, listId: string, listName: string, index?: number): void {
	const item = toPropertyEcommerceItem(property, index);
	if (!item) return;

	pushEcommerceEvent("select_item", {
		item_list_id: listId,
		item_list_name: listName,
		items: [item],
	});
}

export function trackPropertyViewItem(property: PropertyLike): void {
	const item = toPropertyEcommerceItem(property);
	if (!item) return;

	const key = `view_item:${item.item_id}`;
	if (trackedKeys.has(key)) return;
	trackedKeys.add(key);

	pushEcommerceEvent("view_item", {
		items: [item],
	});
}
